var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturedGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "30px",
    viewBox: "0 0 29 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-226.000000, -470.000000)",
    fill: "#00000061",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(223.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2967534,14.0713455 L6.97243297,15.1333877 L12.2626663,20.6074514 L11.0475582,28.2515292 L17.5,24.769951 L23.9524418,28.2515292 L22.7373337,20.6074514 L28.027567,15.1333877 L20.7032466,14.0713455 L17.5,7.23816492 L14.2967534,14.0713455 Z M13.010939,12.3379209 L17.5,2.76183508 L21.989061,12.3379209 L31.972433,13.7855313 L24.7626663,21.2458304 L26.4321735,31.7484708 L17.5,26.9288907 L8.56782646,31.7484708 L10.2373337,21.2458304 L3.02756703,13.7855313 L13.010939,12.3379209 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedGrey);
export default __webpack_public_path__ + "static/media/featuredGrey.687a730c658ec43f0b469e78554dea4f.svg";
export { ForwardRef as ReactComponent };